<template>
    <flex-element v-if="visible" :element-type="elementType" class="fc-paging fc-paging--default">
        <a-button
            v-if="pageTerm > 0 && totalResults > 0"
            class="fc-paging__arrow"
            v-bind="element(1)"
            @click.native="navPage(-1)"
            @element-updated="elementUpdated"
        >
            &lt;
        </a-button>

        <button
            v-for="pageNum in currentPages"
            :key="pageNum"
            :class="[pageClass(pageNum), 'fc-paging__number']"
            @click="goPage(pageNum)"
        >
            {{ pageNum }}
        </button>

        <a-button
            v-if="(pageTerm + 1) < totalPages && totalResults > 0"
            class="fc-paging__arrow"
            v-bind="element(2)"
            @click.native="navPage(1)"
            @element-updated="elementUpdated"
        >
            &gt;
        </a-button>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { processPagination } from '@/utils/pagination';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    mixins: [baseOrganism, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Search Page Range',
        },

        name: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        tag: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            pagesAtOnce: 5,
            pageSize: 10,
            totalResults: 0,
            page: 0,
            urlParams: new URLSearchParams(window.location.search),
            showPageRage: false,
            showIndividualPages: false,
            currentPages: [],
            visible: false,
        };
    },

    computed: {
        pageSizeTerm() {
            return Number(this.urlParams.get('pageSize') || this.pageSize);
        },

        totalPages() {
            return Math.ceil(this.totalResults / this.pageSizeTerm);
        },

        pageTerm() {
            const pageNum = Number(this.urlParams.get('page'));
            return Number(pageNum > 0 ? pageNum - 1 : pageNum || this.page);
        },
    },

    watch: {
        urlParams: {
            handler() {
                this.page = this.pageTerm;
            },
            immediate: true,
        },
    },

    mounted() {
        this.listenOnRoot('flex::collection::search-data', this.processPaging);
        this.listenOnRoot('flex::collection::query-refresh', this.updatePaging);
        this.listenOnRoot('flex::collection::search-properties', this.updateProperties);
    },

    methods: {
        pageClass(num) {
            if (num - 1 === this.pageTerm) {
                return STATE_CLASSES.SELECTED;
            }
            return '';
        },

        navPageBrowser(page) {
            this.urlParams = new URLSearchParams(window.location.search);
            if (this.urlParams.get('page')) {
                this.urlParams.set('page', page + 1);
            } else {
                this.urlParams.append('page', page + 1);
            }

            window.history.replaceState({}, '', `${ window.location.pathname }?${ this.urlParams }`);
            this.emitOnRoot('flex::collection::query-refresh');
        },

        navPage(step) {
            this.navPageBrowser(this.pageTerm + step);
        },

        goPage(page) {
            this.navPageBrowser(page - 1);
        },

        updatePaging() {
            this.urlParams = new URLSearchParams(window.location.search);
            if (this.urlParams.get('page')) {
                this.page = Number(this.urlParams.get('page'));
            } else {
                this.page = 0;
            }
            this.visible = false;
        },

        processPaging(data) {
            this.totalResults = data && data.results ? data.results.totalCount : 0;
            this.currentPages = processPagination(data, this.pagesAtOnce, this.pageSizeTerm, this.pageTerm);
            console.log(this.currentPages);
            if (this.totalResults > 0) {
                this.visible = true;
            }
        },

        updateProperties(searchProperties) {
            this.pageSize = searchProperties && Number(searchProperties.pageSize) > 0 ? searchProperties.pageSize : this.pageSize;
        },
    },
};
</script>

<style lang="scss">
.fc-paging {
    &__number {
        margin-left: 5px;
        margin-right: 5px;
        border-bottom: solid 1px transparent;

        &:hover {
            cursor: pointer;
        }

        &.#{ $is-selected } {
            border-bottom-color: black;
        }
    }
}
</style>
